import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9694085c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-container" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "dashboard-tabs" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard-item-header" }, "Faturamento de Gestão de Marcas", -1))
const _hoisted_5 = { class: "filter-date" }
const _hoisted_6 = ["max", "min"]
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "dashboard-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardBrandsTabs = _resolveComponent("DashboardBrandsTabs")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_DashboardBrandsTabs)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "month",
          max: _ctx.filters.maxDate,
          min: _ctx.filters.minDate,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.date) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlerDate && _ctx.handlerDate(...args))),
          id: "control-date-date",
          name: "control-date-date",
          class: "input-date"
        }, null, 40, _hoisted_6), [
          [_vModelText, _ctx.filters.date]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, _toDisplayString(_ctx.currentFormattedDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_view)
    ])
  ]))
}